import { gatewayInstance } from "../server/gateway";
import { MEETING_APPLICATION_ID } from "@/baseComponents/Meeting/utils";
export enum ApprovalResult {
  Reject = 0,
  Agree
}
export enum ApplicationStatus {
  Unadd = 0,
  Added,
  Processing // 审核中
}
export interface AppStoreApplication {
  appId: string;
  applicationId: string;
  purchaseQuantity: number;
  paymentStrategy: number;
  poster: string;
  name: string;
  icon: string;
  brief: string;
  description: string;
  useAgreement: string;
  privacyAgreement: string;
  docUrl: string;
  keyword: string;
  preview: string;
  supportedLang: string;
  version: string;
  maxVersion: string;
  minVersion: string;
  recommended: number;
  added: number;
  homeUrl: string;
  tags: any[];
}

/**
 *
 * 拒绝申请
 * @returns
 * @param opts
 */
export async function approveApplicationAddition(opts: {
  appKey: string;
  applicationId: string;
  applicantUserId: string;
  approvalResult: ApprovalResult;
  approvalComments?: string;
}) {
  return gatewayInstance.request({
    api: "appstore.approveApplicationAddition",
    method: "POST",
    body: opts
  });
}

export async function getStoreApplication(opts: { appKey: string; applicationId: string }) {
  return gatewayInstance.request({
    api: "appstore.getStoreApplication",
    method: "POST",
    body: opts
  });
}

/**
 * 提交免费试用申请
 * @returns
 * @param opts
 */

export async function submitFreeUseApply(opts: {
  applyApplicationId: string;
  applyPhone: string;
  applyDesc: string;
}) {
  // console.log("this is get", gatewayInstance);
  return gatewayInstance.request({
    api: "appstore.freeUseApply.submitFreeUseApply",
    method: "POST",
    body: opts
  });
}

/**
 * 判断免费试用
 * @returns
 * @param opts
 */
export async function judgeFreeUse(opts: { applicationId: string }) {
  if (Object.values(MEETING_APPLICATION_ID).includes(opts.applicationId)) {
    return gatewayInstance.request({
      api: "conference.checkFreeUse",
      method: "POST",
      body: opts
    });
  }
  return gatewayInstance.request({
    api: "appstore.payUser.judgeFreeUse",
    method: "POST",
    body: opts
  });
}

/**
 * 获取机器人详情
 * @returns
 * @param opts
 */
export async function getRobotDetail(opts: { robotId: string }) {
  return gatewayInstance.request({
    api: "appStore.getRobotDetail",
    method: "POST",
    body: opts
  });
}

/**
 * 批量获取机器人详情
 * @returns
 * @param opts
 */
export async function getRobotDetails(opts: { robotId: string[] }) {
  return gatewayInstance.request({
    api: "appStore.getRobotDetails",
    method: "POST",
    body: opts
  });
}
